module.exports = __webpack_public_path__ + "static/img/image_filter.8419c88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/home/image_filter.jpg
// module id = xHl+
// module chunks = 2